

import style from './organisation.css';
import React, { useState, useEffect, useRef } from "react";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner'
import { BASE_API_URL } from '../../config/Url-config';
import { Row, Col } from 'react-bootstrap';
import RoleTemplate from './RoleTemplate';
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { FiRefreshCw } from "react-icons/fi";
import * as apiUtility from "../../config/APIUtils";
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import KeyboardDoubleArrowUpOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowUpOutlined';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import { Divider, FormControl, IconButton, InputLabel, MenuItem, Paper, Select, Tooltip, Typography } from '@mui/material';
import { RiFileExcel2Line } from 'react-icons/ri';
import SuccessPopUp from '../Utility/SuccessPopUp';
import ErrorPopUp from '../Utility/ErrorPopUp';
import PolicyFormModal from "../Policy_Components/PolicyFormModal";
import PolicyViewModal from "../Policy_Components/PolicyViewModal";

export default function HomePolicyComponent(props) {

    const ref = useRef(null);

    const [editRoleDetail, setEditRoleDetail] = useState({});
    const [MicroCredShow, setMicroCredShow] = useState(false);
    const handleCloseMicroCred = () => setMicroCredShow(false);
    const handleshowMicroCred = () => setMicroCredShow(true);
    const [roleDetailOverWrite, setroleDetailOverWrite] = useState({});
    const [showTemplateDetails, setShowTemplateDetails] = useState(false)
    const [templateDetails, setTemplateDetails] = useState({});
    const [showArchiveWarning, setArchiveWarningShow] = useState(false);
    const handleCloseArchiveWarning = () => setArchiveWarningShow(false);
    const handleshowArchiveWarning = () => setArchiveWarningShow(true);
    const [showPosition, setPositionShow] = useState(false);
    const handleClosePosition = () => setPositionShow(false);
    const [isSticky, setIsSticky] = useState(false);
    const [tableOffset, setTableOffset] = useState(0);
    const [editRowWidth, setEditTableRowWidth] = useState('');
    const [dataForSuccessPopup, setDataForSuccessPopup] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');
    const [positionDetail, setPositionDetail] = useState({});
    const handleShowPosition = () => {
        setRoleDetailOptions({});
        setShowDetailForm(false);
        setPositionShow(true);
        setPositionDetail({});
    }
    const [showOption, setShowOption] = useState(false);
    const handleCloseOption = () => setShowOption(false);
    const handleShowOption = () => setShowOption(true);
    const [showOverwriteWarning, setOverwriteWarning] = useState(false);
    const handleCloseOverwriteWarning = () => setOverwriteWarning(false);
    const handleShowOverWriteWarning = () => {
        setOverwriteWarning(true);
    }
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    const [trainStandards, setTrainStandards] = useState([]);

    // const params = useParams().id;
    const params = props.id;
    const [roleDetails, setRoleDetails] = useState([]);
    const [radioValue, setRadioButtonValue] = useState([]);
    const [dispMicroCred, setDispMicroCred] = useState('');
    const [globalPolicyRole, setGlobalPolicyRole] = useState({});
    const [trainData, setTrainStandardsData] = useState([])
    const [policyList, setpolicyList] = useState([]);
    const [showCreateRole, setShowCreateRole] = useState(false);
    const [counter, setCounter] = useState(0);
    const [globalRole, setGlobalRole] = useState({});
    const [loading, setLoading] = useState(false);
    const [showSpinner, setshowSpinner] = useState(false);
    const toggleshowSpinner = () => setshowSpinner(!showSpinner);
    const [checkListRoleId, setCheckListRoleId] = useState('');
    const [checkListHomeId, setCheckListHomeId] = useState('');
    const [editTableWidth, setEditTableWidth] = useState('');
    const [homeArchivedStates, sethomeArchivedStates] = useState([]);
    const [archivedObj, setArchivedObj] = useState({});
    const [checkListRoleDetails, setCheckListRoleDetailsModal] = useState(false);
    const handleCloseCheckListRoleDetails = () => {
        setCheckListRoleDetailsModal(false);
        setShowOverWriteOption(false);
        setroleDetailOverWrite({})
    }
    const [homesType, setHomesType] = useState(JSON.parse(sessionStorage.getItem('home_types')));
    const [selectedHomeType, setSelectedHomeType] = useState(homesType[0]);
    const [selectedArchiveType, setSelectedArchiveType] = useState({ "name": "Active", "value": "2" });

    const [showDetailForm, setShowDetailForm] = useState(false);
    const [orgList, setOrgList] = useState([]);
    const [homeList, setHomeList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [roleDetail, setRoleDetail] = useState();
    const [dispRoleDetail, setDispRoleDetail] = useState('');
    const [roleDetailshow, setRoleDetailShow] = useState(false);
    const handleroleDetailClose = () => setRoleDetailShow(false);
    const handleroleDetailShow = () => setRoleDetailShow(true);
    const handleShowDetailForm = () => {
        setShowDetailForm(!showDetailForm);
        setRoleDetailOptions({});
    }
    const [roleDetailOptions, setRoleDetailOptions] = useState({});
    const [showOverWriteOption, setShowOverWriteOption] = useState(false);
    const handleShowOverWriteOption = () => setShowOverWriteOption(!showOverWriteOption);
    const tableRef = useRef();

    const [policyViewModal, setPolicyViewModal] = useState(false);

    const [showPolicyDoc, setShowPolicyDoc] = useState(false);
    const [policyData, setPolicyData] = useState({});

    const [orgPolicyList, setOrgPolicyList] = useState({});

    const handleShowPolicyDoc = (val) => {
        if (val != {}) {
            setPolicyData(val);
        }
        else {
            setPolicyData({});
        }
        // setPolicyData({
        //     policyId: "PC-105",
        //     versionNumber: 2,
        //     archived: false,
        //     isMajorChange: false,
        //     title: "Test Policy Document Updated",
        //     type: "Test Type updated",
        //     description: "Test Description Updated",
        //     expiryValue: 0,
        //     expiryType: "months",
        //     org_id: params,
        //     home_id: "",
        //     reAssignAll: false,
        //     url:"https://carepassportpolicy.blob.core.windows.net/policy-docs/dev/1761684425260~Carepassport_UserAuditReport-1962.pdf"
        // });
        setPositionDetail({})
        setRoleDetailOptions({});
        // setNewStandard('');
        // setErrors(false); 
        // setTrainStdErrorMsg('');
        setShowPolicyDoc(true);
    };
    const handleClosePolicyDoc = () => setShowPolicyDoc(false);

    const archiveType = [{ 'name': "All", 'value': "1" }, { 'name': "Active", 'value': "2" }, { 'name': "Archived", 'value': "3" }]
    useEffect(() => {
        //console.log(props)
        if (props) {

            getInitialData();

        }

    }, [props.id, selectedHomeType, selectedArchiveType]);





    function handleHomeTypeChange(homeType) {
        console.log(homeType)
        setSelectedHomeType(homeType)
        //  getHomeData()

    }
    function handleArchiveTypeChange(archiveType) {
        setSelectedArchiveType(archiveType);

    }

    function setTableWidthFunc(resLength) {
        if (resLength >= 0) {
            switch (resLength) {
                case 0: setEditTableWidth('68vh');
                    setEditTableRowWidth('100%');
                    break;
                case 1: setEditTableWidth('130vh');
                    setEditTableRowWidth('52.5%');
                    break;
                case 2: setEditTableWidth('170vh');
                    setEditTableRowWidth('40%');
                    break;
                case 3: setEditTableWidth('200vh');
                    setEditTableRowWidth('34%');
                    break;
                case 4: setEditTableWidth('230vh');
                    setEditTableRowWidth('29.6%');
                    break;
                case 5: setEditTableWidth('270vh');
                    setEditTableRowWidth('25.2%');
                    break;
                case 6: setEditTableWidth('310vh');
                    setEditTableRowWidth('22%');
                    break;
                case 7: setEditTableWidth('360vh');
                    setEditTableRowWidth('19%');
                    break;
                case 8: setEditTableWidth('405vh');
                    setEditTableRowWidth('16.8%');
                    break;
                case 9: setEditTableWidth('450vh');
                    setEditTableRowWidth('15.2%');
                    break;
                // 10 
                case 10: setEditTableWidth('500vh');
                    setEditTableRowWidth('13.7%');

                    break;
                case 11: setEditTableWidth('545vh');
                    setEditTableRowWidth('12.5%');

                    break;
                case 12: setEditTableWidth('590vh');
                    setEditTableRowWidth('11.58%');
                    break;
                case 13: setEditTableWidth('640vh');
                    setEditTableRowWidth('10.68%');
                    break;
                case 14: setEditTableWidth('685vh');
                    setEditTableRowWidth('10%');
                    break;
                case 15: setEditTableWidth('735vh');
                    setEditTableRowWidth('9.3%');
                    break;
                case 16: setEditTableWidth('780vh');
                    setEditTableRowWidth('8.7%');
                    break;
                case 17: setEditTableWidth('825vh');
                    setEditTableRowWidth('8.25%');

                    break;
                case 18: setEditTableWidth('870vh');
                    setEditTableRowWidth('7.8%');

                    break;
                case 19: setEditTableWidth('930vh');
                    setEditTableRowWidth('7.34%');

                    break;
                case 20: setEditTableWidth('985vh');
                    setEditTableRowWidth('6.9%');

                    break;
                case 21: setEditTableWidth('1030vh');
                    break;
                case 22: setEditTableWidth('1075vh');
                    break;
                case 23: setEditTableWidth('1400vh');
                    break;
                case 24: setEditTableWidth('1120vh');
                    break;
                case 25: setEditTableWidth('1170vh');
                    break;
                case 26: setEditTableWidth('1220vh');
                    break;
                case 27: setEditTableWidth('1270vh');
                    break;
                case 28: setEditTableWidth('1325vh');
                    break;
                case 29: setEditTableWidth('1370vh');
                    break;
                case 30: setEditTableWidth('1420vh');
                    break;
                case 31: setEditTableWidth('1480vh');
                    break;
                case 32: setEditTableWidth('1560vh');
                    break;
                case 33: setEditTableWidth('1620vh');
                    break;
                case 34: setEditTableWidth('1680vh');
                    break;
                case 35: setEditTableWidth('1740vh');
                    break;
                case 36: setEditTableWidth('1800vh');
                    break;
                case 37: setEditTableWidth('1860vh');
                    break;
                case 38: setEditTableWidth('1920vh');
                    break;
                case 39: setEditTableWidth('1980vh');
                    break;
                case 40: setEditTableWidth('2040vh');
                    break;
                case 41: setEditTableWidth('2300vh');
                    break;
                case 42: setEditTableWidth('2360vh');
                    break;
                case 43: setEditTableWidth('2420vh');
                    break;
                case 44: setEditTableWidth('2480vh');
                    break;
                case 45: setEditTableWidth('2560vh');
                    break;
                case 46: setEditTableWidth('2620vh');
                    break;
                case 47: setEditTableWidth('2680vh');
                    break;
                case 48: setEditTableWidth('2760vh');
                    break;
                case 49: setEditTableWidth('2820vh');
                    break;
                case 50: setEditTableWidth('2880vh');
                    break;
                case 51: setEditTableWidth('2940vh');
                    break;
                case 52: setEditTableWidth('3000vh');
                    break;
                case 53: setEditTableWidth('3070vh');
                    break;
                case 54: setEditTableWidth('3140vh');
                    break;
                case 55: setEditTableWidth('3210vh');
                    break;
                case 56: setEditTableWidth('3280vh');
                    break;
                case 57: setEditTableWidth('3350vh');
                    break;
                case 58: setEditTableWidth('3240vh');
                    break;
                case 59: setEditTableWidth('3310vh');
                    break;
                case 60: setEditTableWidth('3380vh');
                    break;
                default: setEditTableWidth('3450vh');
            }
            // var tableWidth = document.getElementById("tableWidth");
            // tableWidth.style.width = editTableWidth;
        }
    }
    async function getInitialData() {
        var tempTrainingData = [];
        var tempHomeCheckList = [];
        let orgPolicyStandards = [];
        setshowSpinner(true)

        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "orgnization/getOrgTrainStandardForHome/" + props.orgId;
        await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            if (res != 'Something went wrong!' || res != 'No Standards Found!') {
                setTrainStandardsData(res.data.tempStandardStatus)
                tempTrainingData = res.data.tempStandard;
                orgPolicyStandards = res.data.policyStandards;
            }
        }).catch((error) => {
            console.error(error);
        });

        setshowSpinner(true)


        //var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "policy/getHomePolicyList/" + params + "/" + props.orgId;
        await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            if (res.data != 'Something went wrong!' && res.data != 'No Course Found!' && res.data != 'No Policy Found!') {
                setpolicyList(res.data);
            }
        }).catch((error) => {
            console.error(error);
            setpolicyList([]);
        });

        setshowSpinner(true)

        //let apiRequest = apiUtility.apiInputRequest;
        
        apiRequest.endPoint = "policy/showPolicyHomeCheckList/" + params;
        await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            if (res.data != 'Something went wrong!' && res.data != 'No Role Found!' && res.data.length > 0) {
                var tempRoleArray = [];
                if (selectedArchiveType.value === '1') {
                    tempRoleArray = res.data;
                }
                else if (selectedArchiveType.value === '2') {
                    tempRoleArray = res.data.filter(item => ((item.archived === false) || (item.archived === 'False') || (item.archived === 'false')));
                }
                else {
                    tempRoleArray = res.data.filter(item => ((item.archived === true) || (item.archived === 'True') || (item.archived === 'true')));
                }
                setRoleDetails(tempRoleArray);
                setshowSpinner(false)
                setShowCreateRole(false)

                tempHomeCheckList = tempRoleArray;
                let resLength = tempRoleArray.length
                var arr = {};
                tempRoleArray.forEach(data => {
                    arr[data.role_id] = data.archived;
                });
                sethomeArchivedStates(prevStates => ({ ...prevStates, ...arr }));
                var globalPolicyRoleObj = {};
                tempHomeCheckList.forEach(element => {
                    //var trainCourseOrgData = tempTrainingData[element.role_id]
                    let currentPolicyStandards = undefined != orgPolicyStandards[element.role_id] ? orgPolicyStandards[element.role_id] : [];
                    let tempObj;
                    let policyArr = []

                    if (currentPolicyStandards.length > 0) {
                        for (const data of element?.policy_arr) {
                            tempObj = currentPolicyStandards.some(item => (item && (item.policyId === data.policyId)))
                            if (tempObj == true) {
                                policyArr.push(data.policyId)
                            }
                        }
                    }
                    globalPolicyRoleObj[element.role_id] = policyArr

                });
                setGlobalPolicyRole(globalPolicyRoleObj);
                setTableWidthFunc(resLength);
            }
            else {
                setShowCreateRole(true)
                setRoleDetails([])
                setshowSpinner(false)
            }
        }).catch((error) => {
            console.error(error);
            setShowCreateRole(true)
            setshowSpinner(false)
        });


        apiRequest.endPoint = "orgnization/getOrganisationDetails/" + props.orgId;
        await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            if (res.data != 'Something went wrong!' && res.data != 'No Standards Found!' && res.data != 'No Organisation Found!') {
                var tempRoleArray;
                if (selectedArchiveType.value === '1') {
                    tempRoleArray = res.data[0]?.train_standards;
                }
                else if (selectedArchiveType.value === '2') {
                    tempRoleArray = res.data[0]?.train_standards?.filter(item => ((item.archived === false) || (item.archived === 'False') || (item.archived === 'false')));
                }
                else {
                    tempRoleArray = res.data[0]?.train_standards?.filter(item => ((item.archived === true) || (item.archived === 'True') || (item.archived === 'true')));
                }
                setTrainStandards([...tempRoleArray]);
            }
        })

        apiRequest.endPoint = "policy/getOrgPolicyList/" + props.orgId;
        await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            if (res.data != 'Something went wrong!' && res.data != 'No Policy Found!' && res.data != 'No Course Found!') {
                setOrgPolicyList([...res.data]);
            }
            else {
                setOrgPolicyList([]);
            }
        })

        setshowSpinner(false)
    }
   // This is original function
    async function handleCheckOnChange(event, policyDetail, roleDetail, id) {
        var tempArray = [...roleDetails];
        if (event.target.checked) {
            if (!tempArray[id].policy_arr) {
                tempArray[id].policy_arr = [];
            }

            tempArray[id].policy_arr.push({ "policyId": policyDetail.policyId, "title": policyDetail.title });
            tempArray[id].isRemoved = false;
            tempArray[id].editedPolicyId = policyDetail.policyId
        }
        else {
            tempArray[id].policy_arr = tempArray[id].policy_arr.filter(function (el) { return el.policyId != policyDetail.policyId; });
            tempArray[id].isRemoved = true;
        }
        
        setRoleDetails(tempArray)

        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "policy/editPolicyDetails/";
        apiRequest.data = roleDetail;
        apiUtility.updateAsyncAPIDataPUT(apiRequest).then(res => {
            getInitialData()
        }).catch((error) => {
            console.error(error);
            setshowSpinner(false);
        });


    }

    // This is new function
// async function handleCheckOnChange(event, policyDetail, roleDetail, id) {

//     // 1. Clone the array
//     let tempArray = [...roleDetails];

//     // 2. Clone the object at index
//     tempArray[id] = { ...tempArray[id] };

//     // 3. Clone the policy_arr (avoid mutating nested array)
//     tempArray[id].policy_arr = [...(tempArray[id].policy_arr || [])];

//     if (event.target.checked) {
//         tempArray[id].policy_arr.push({
//             policyId: policyDetail.policyId,
//             title: policyDetail.title
//         });

//         tempArray[id].isRemoved = false;
//         tempArray[id].editedPolicyId = policyDetail.policyId;
//     } else {
//         tempArray[id].policy_arr = tempArray[id].policy_arr.filter(
//             el => el.policyId !== policyDetail.policyId
//         );

//         tempArray[id].isRemoved = true;
//     }

//     // 4. Update state with new references
//     setRoleDetails(tempArray);

//     // 5. API call
//     let apiRequest = apiUtility.apiInputRequest;
//     apiRequest.endPoint = "policy/editPolicyDetails/";
//     apiRequest.data = roleDetail;

//     apiUtility.updateAsyncAPIDataPUT(apiRequest)
//         .then(res => {
//             getInitialData();
//         })
//         .catch((error) => {
//             console.error(error);
//             setshowSpinner(false);
//         });
// }

    async function getMicrodetails(event, val) {
        if (val.is_orgId == true) {
            setPolicyViewModal(true);
        }
        else {
            handleShowPolicyDoc(val);

        }

    }

    function getPolicyText(event, id) {
        let newPositionDetailObj = {};
        newPositionDetailObj = { ...positionDetail };
        if (id === 'pos1')
            newPositionDetailObj.role_name = event.target.value;
        else if (id === 'pos3') {
            const file = event.target.files[0];
            newPositionDetailObj.file = file;
        } else {
            newPositionDetailObj.role_details = event.target.value;
        }

        // Add other fieldsF
        newPositionDetailObj.role_id = String(roleDetails.length + 1);
        newPositionDetailObj.home_id = String(params);
        newPositionDetailObj.archived = false;
        newPositionDetailObj.org_id = (sessionStorage.getItem("orgId") == null ? props.orgId : sessionStorage.getItem("orgId"));

        // Add all fields to FormData


        // Optional: update local state
        setPositionDetail(newPositionDetailObj);

        //console.log("position details:", positionDetail)


    }
    async function savePositionDetail() {
        const formData = new FormData();
        let newPositionDetailObj = {};
        newPositionDetailObj = { ...positionDetail };

        if ((newPositionDetailObj.role_name && newPositionDetailObj.role_details)) {

            for (const key in newPositionDetailObj) {
                formData.append(key, newPositionDetailObj[key]);
            }
            //     if(newPositionDetailObj.file){

            //   formData.append("pdf", newPositionDetailObj.file);
            //     }
            // newPositionDetailObj.policy_arr = JSON.parse(sessionStorage.getItem('roleSelectOption'));
            setPositionDetail(newPositionDetailObj)
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "policy/addDefaultPolicyArrayToHomeCrsRole";
            apiRequest.data = formData;
            apiUtility.sendAsyncAPIDataPOST(apiRequest).then(res => {
                handleClosePosition()
                getInitialData()
            }).catch((error) => {
                console.error(error);
            });
        }

    }

    function handleShowCheckListRoleDetails(e, homeId, roleId) {
        getOrgDetails()

        const params = homeId + "/" + roleId

        const getRoleTemplateUrl = BASE_API_URL + "orgnization/getRoleTemplateDetails/" + homeId + "/" + roleId
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "orgnization/getRoleTemplateDetails/" + homeId + "/" + roleId;
        //apiRequest.data = tempHomeObj;
        apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            if (res == 'Something went wrong!' || res == 'No Role Found!')
                console.log("No data")
            else {
                //console.log(res.data[0]);
                setTemplateDetails(res.data[0])
                if (templateDetails != {})
                    setShowTemplateDetails(true)
            }
        }).catch((error) => {
            setShowTemplateDetails(false)

            console.error(error);
            // setshowSpinner(false);
        });
        setShowTemplateDetails(true)

        setCheckListHomeId(homeId)
        setCheckListRoleId(roleId)
        setCheckListRoleDetailsModal(true);

    }



    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);

        // The application/octet-stream MIME type is used for unknown binary files.
        // It preserves the file contents, but requires the receiver to determine file type,
        // for example, from the filename extension.
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }
    const exportInExcel = async () => {
        var rowsCount = 6;
        //const title = [{A: 'Ontario Long Term Care Orientation Co-operative Webportal - Error History Report'}];
        const title = [{ '1': 'CarePassport - Home Role Policy Template' }];

        var reportView = [{ '1': 'Name', '2': 'User ID', '3': 'Role', '4': 'Date' }];
        reportView.push({
            '1': sessionStorage.getItem('fullName'),
            '2': sessionStorage.getItem('userId'),
            '3': (sessionStorage.getItem('userType') !== null) ? sessionStorage.getItem('userType').toUpperCase() : "User",
            '4': (new Date().toLocaleString()).split(',')[0]
        });
        reportView.push("");
        reportView.push("");

        // let reportHeaders = {A:'C-Number',B:'First Name',C:'Last Name',D:'Course Code',E:'Course Name',F:'Completion Date',G:'Last Processed',H:'Failure Reason'};
        // finalExcelArray.push(reportHeaders);
        var finalExcelArray = [];

        for (var j = 0; j < policyList.length; j++) {
            var tempExcelArray = [];
            let policy = policyList[j].title + '(' + policyList[j].policyId + ')';
            tempExcelArray.push(policy);
            for (var i = 0; i < roleDetails.length; i++) {

                // tempExcelObj.course = course;
                if (roleDetails[i].policy_arr?.find(item => item.policyId == policyList[j].policyId) != undefined) {
                    tempExcelArray.push('Y')

                }
                else {
                    tempExcelArray.push('N')
                }

            }
            finalExcelArray.push(tempExcelArray)
        }
        // const title = [{ '1': 'Home Checklist', '2': new Date().toLocaleString() }];
        let userTable = [];
        var tObj = [];
        var index = '1';
        tObj[index] = 'Policies';
        for (var i = 0; i < roleDetails.length; i++) {
            index = String(parseInt(index) + 1);

            tObj[index] = roleDetails[i].role_name + '(Archived:' + roleDetails[i].archived + ')'

        }
        userTable.push(tObj)
        //  console.log("finalExcelArray ",finalExcelArray)
        for (var i = 0; i < finalExcelArray.length; i++) {
            var index = '1';
            let tempObj = {};
            for (var j = 0; j < finalExcelArray[i].length; j++) {
                tempObj[index] = finalExcelArray[i][j]

                // console.log("index ",index)
                index = String(parseInt(index) + 1);
            }
            userTable.push(tempObj);
            //     userTable.push({
            //         [index] : finalExcelArray[i][j]

            // });  
        }

        const finalData = [...title, ...reportView, ...userTable];
        const worksheet = XLSX.utils.json_to_sheet(finalData, {
            skipHeader: true,
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, +"_Report");
        const workbookblob = workbook2blob(workbook);
        // var headerIndexes = [];
        // finalData.forEach((data, index) =>
        //     data["A"] === "Course Code" ? headerIndexes.push(index) : null
        // );
        const dataInfo = {
            titleCell: "A2",
            titleRange: "A1:L1",
            tbodyRange: `A7:H${finalData.length}`,
            uHeadRange: `A2:G2`,
            uBodyRange: `A3:G3`,

        };


        XlsxPopulate.fromDataAsync(workbookblob).then((workbook) => {
            workbook.sheets().forEach((sheet) => {
                for (var i = 1; i <= roleDetails.length + 1; i++) {
                    sheet.column(i).width(40);
                }


                sheet.range(dataInfo.titleRange).merged(true).style({
                    // bold: true,
                    // fontFamily:"Arial",
                    horizontalAlignment: "left",
                    // verticalAlignment: "left",
                });
                sheet.range(dataInfo.uHeadRange).style({
                    // fill: "A6A6A6",
                    //bold: true,
                    horizontalAlignment: "left",
                });
                sheet.range(dataInfo.uBodyRange).style({
                    // bold: true,
                    horizontalAlignment: "left",
                });
                if (dataInfo.tbodyRange) {
                    sheet.range(dataInfo.tbodyRange).style({
                        horizontalAlignment: "left",
                    });
                }

            });

            return workbook.outputAsync().then((workbookBlob) => {

                const downloadAnchorNode = document.createElement("a");
                downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                downloadAnchorNode.setAttribute("download", "ChecklistSheet-" + ".xlsx");
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
                //alert('File downloaded successfully.');
                // setauditalertshow(true);


            });
        });


        //return XLSX.writeFile(blob, "UserAuditReport_"+userList.user_id+"_LCPT.xlsx");//URL.createObjectURL(workbookBlob));
    }
    function openDispRoleDetail(event, data) {
        ////console.log(event.target.value)
        setDispRoleDetail(data)
        handleroleDetailShow()

    }

    function getOrgDetails() {
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "orgnization/getOrganizationList";
        apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            ////console.log(res)
            setOrgList(res.data);
        }).catch((error) => console.error(error));
    }

    function selectOrgForRole(event) {
        if (event.target.value) {
            var tempRoleDetails = {};
            tempRoleDetails.org_id = event.target.value;
            tempRoleDetails.home_id = '';
            tempRoleDetails.role_id = '';
            // setHomeList([]);
            // setRoleList([]);
            setRoleDetailOptions(tempRoleDetails)
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/getHomesList/" + event.target.value;
            apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                //console.log(res)
                if (res.length == 0 || !res.data || !res || res.data === 'No Home Found!') {
                    setHomeList([])
                }
                else {
                    setHomeList(res.data);
                    let apiRequest = apiUtility.apiInputRequest;
                    apiRequest.endPoint = "orgnization/getOrganisationDetails/" + event.target.value;
                    apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {

                        if (res != 'Something went wrong!' && res != 'No Standards Found!' && res.data) {
                            setRoleList(res.data[0].train_standards)
                        }
                        else {
                            setRoleList([]);

                        }

                    }).catch((error) => console.error(error))
                }
            }).catch((error) => console.error(error))

        }
    }

    function selectHomeForRole(event) {
        if (event.target.value) {
            //console.log("home", event.target.value);
            var tempRoleDetails = { ...roleDetailOptions };
            tempRoleDetails.home_id = event.target.value;
            tempRoleDetails.role_id = '';

            setRoleDetailOptions(tempRoleDetails)

            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/showHomeCheckList/" + event.target.value;

            apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {

                if (res.data === 'No Role Found!') {
                    setRoleList([]);

                }
                else {
                    setRoleList(res.data);
                }
            }).catch((error) => console.error(error))
        }
    }

    function selectRoleForCopy(event) {
        if (event.target.value) {
            var tempRoleDetails = { ...roleDetailOptions };
            tempRoleDetails.role_id = event.target.value;
            var copyRoleDetails = roleList.find(item => item.role_id === event.target.value)
            tempRoleDetails.policy_arr = copyRoleDetails.policy_arr
            var newPositionDetailObj = { ...positionDetail };
            newPositionDetailObj.policy_arr = copyRoleDetails.policy_arr;
            setPositionDetail(newPositionDetailObj)
            setRoleDetailOptions(tempRoleDetails)

            var roleObj = {};
            roleObj.role_id = copyRoleDetails.role_id;
            roleObj.role_details = copyRoleDetails.role_details;
            roleObj.role_name = copyRoleDetails.role_name;
            roleObj.policy_arr = copyRoleDetails.policy_arr;
            roleObj.archived = copyRoleDetails.archived;
            //sessionStorage.setItem('roleSelectOption', JSON.stringify(copyRoleDetails.policy_arr));

            setRoleDetail(roleObj)
        }


    }

    function copyRole() {
        sessionStorage.setItem('copyRoleObj', JSON.stringify(roleDetail));
    }
    function clearAllSetting() {
        setRoleList([]);
        setOrgList([]);
        setHomeList([]);
    }

    function selectOrgForEdit(event) {
        if (event.target.value) {
            var tempRoleDetails = {};
            tempRoleDetails.org_id = event.target.value;
            tempRoleDetails.home_id = '';
            tempRoleDetails.role_id = '';
            setEditRoleDetail(tempRoleDetails)
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/getHomesList/" + event.target.value;
            apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                if (res.length == 0 || !res.data || !res || res.data === 'No Home Found!') {
                    setHomeList([])
                }
                else {
                    setHomeList(res.data);
                    let apiRequest = apiUtility.apiInputRequest;
                    apiRequest.endPoint = "orgnization/getOrganisationDetails/" + event.target.value;
                    apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {

                        if (res != 'Something went wrong!' && res != 'No Standards Found!' && res.data) {
                            setRoleList(res.data[0].train_standards)
                        }
                        else {
                            setRoleList([]);

                        }

                    }).catch((error) => console.error(error))
                }
            }).catch((error) => console.error(error))


        }
    }
    function selectHomeForEdit(event) {
        //setRoleList([]);
        if (event.target.value) {
            var tempRoleDetails = { ...editRoleDetail };
            tempRoleDetails.home_id = event.target.value;
            tempRoleDetails.role_id = '';

            setEditRoleDetail(tempRoleDetails)

            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/showHomeCheckList/" + event.target.value;

            apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                setRoleDetailOptions(tempRoleDetails);
                if (res.data === 'No Role Found!') {
                    setRoleList([]);

                }
                else {
                    setRoleList(res.data);
                }

            }).catch((error) => console.error(error))
        }

    }
    function selectRoleForEdit(event) {
        if (event.target.value) {
            var tempRoleDetails = { ...editRoleDetail };
            tempRoleDetails.role_id = event.target.value;
            setEditRoleDetail(tempRoleDetails);
            var copyRoleDetails = roleList.find(item => item.role_id === event.target.value);
            setroleDetailOverWrite(copyRoleDetails);

        }


    }
    function handleOverWriteRole(role_id) {
        if (roleDetailOverWrite && roleDetailOverWrite.policy_arr && params && role_id) {


            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "policy/editPolicyDetails/";
            apiRequest.data = { "home_id": params, "role_id": role_id, "policy_arr": roleDetailOverWrite.policy_arr };
            apiUtility.updateAsyncAPIDataPUT(apiRequest).then(res => {
                //console.log(res)
                setshowSpinner(false);
                handleCloseOverwriteWarning();
                handleCloseCheckListRoleDetails();
                getInitialData()
            }).catch((error) => {
                console.error(error);
                setshowSpinner(false);
            });


        }
        else {
            alert("please select all fields!")
        }

    }

    // const renderTooltip1 = (props) => (
    //     <Tooltip id="button-tooltip" {...props}>
    //         Refresh Template
    //     </Tooltip>
    // );
    const scroll = (scrollOffset, direction) => {
        if (direction === 'horizontal') {
            ref.current.scrollLeft += scrollOffset;
        } else if (direction === 'vertical') {
            ref.current.scrollTop += scrollOffset;
        }
    };

    return (

        <div className="w-100" style={{ marginTop: "5vh" }} id='tableWidth'>
            <Modal show={checkListRoleDetails} onHide={handleCloseCheckListRoleDetails} className=" custom-map-modal">
                <Modal.Header closeButton>
                    <Modal.Title> Role Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RoleTemplate roleId={checkListRoleId} homeId={checkListHomeId} />
                    <Button variant="primary" onClick={handleShowOverWriteOption}>overwrite from existing</Button>
                    {showOverWriteOption ?
                        <div>
                            <Row >
                                <Col>
                                    <Form.Label>Organisation</Form.Label>
                                    <Form.Select className="form-select-sm" aria-label="Default select example" onChange={selectOrgForEdit}>
                                        <option value=''>Select an Organization</option>
                                        {orgList?.map((data) => {
                                            return <option value={data.org_id}>{data.org_name}</option>;
                                        })}
                                    </Form.Select>
                                </Col>

                                <Col>
                                    <Form.Label>Home</Form.Label>
                                    <Form.Select className="form-select-sm" aria-label="Default select example" onChange={selectHomeForEdit}>
                                        <option value=''>Select a Home</option>

                                        {homeList?.map((data) => {
                                            if (data.homeActiveStatus === true) {
                                                return <option value={data.home_id}>{data.name}</option>;
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </Form.Select>
                                </Col>
                            </Row>
                            <Row >
                                <Col>
                                    <Form.Label>Role</Form.Label>
                                    <Form.Select className="form-select-sm" aria-label="Default select example" onChange={selectRoleForEdit}>
                                        <option value=''>Select a Role</option>
                                        {roleList?.map((data) => {
                                            if (data.archived === "False" || data.archived === "false" || data.archived === false) {
                                                return <option value={data.role_id}>{data.role_name}</option>;
                                            } else {
                                                return null;
                                            }
                                            // return <option value={data.role_id}>{data.role_name}</option>;
                                        })}
                                    </Form.Select>
                                </Col>
                                <Col></Col>

                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3 col-xs-6" controlId="formBasicEmail">
                                        <Form.Label style={{ display: "block" }}><b>Courses to overwrite this Role : </b></Form.Label>
                                        {roleDetailOverWrite && roleDetailOverWrite.policy_arr ? (
                                            roleDetailOverWrite.policy_arr.map((data, id) => {
                                                return <ul key={id}>
                                                    <li><b>{data.id}</b> - {data.details}</li>
                                                </ul>
                                            })
                                        ) : (

                                            <p>-</p>)
                                        }
                                    </Form.Group>
                                </Col>

                                <Col>
                                    <Form.Group className="mb-3 col-xs-6" controlId="formBasicEmail">
                                        <Form.Label style={{ display: "block" }}><b>Present Courses for this Role : </b></Form.Label>
                                        {showTemplateDetails && templateDetails.policy_arr ? (
                                            templateDetails.policy_arr.map((data, id) => {
                                                return <ul key={id}>
                                                    <li><b>{data.id}</b> - {data.details}</li>
                                                </ul>
                                            })
                                        ) : (

                                            <p>-</p>)
                                        }
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row style={{ "marginTop": "1pc" }}>
                                <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Staff preference </Form.Label>
                                    <ButtonGroup style={{ "width": "100%" }}>
                                        <ToggleButton
                                            key='id1'
                                            id={`radioStaffHome-1`}
                                            type="radio"
                                            variant={'outline-success'}
                                            name="homeStaff-radio"
                                            size="sm"
                                        //disabled={userId == -1?false:true}
                                        // value={radio.value}
                                        // checked={homeStaffStatusValue === radio.value}
                                        // onChange={(e) => { setHomeStaffStatusValue(e.currentTarget.value); setreportSection("") }}
                                        >
                                            Copy Courses
                                        </ToggleButton>
                                        <ToggleButton
                                            key='id2'
                                            id={`radioStaffHome-2`}
                                            type="radio"
                                            variant={'outline-success'}
                                            name="homeStaff-radio"
                                            size="sm"
                                        //disabled={userId == -1?false:true}
                                        // value={radio.value}
                                        // checked={homeStaffStatusValue === radio.value}
                                        // onChange={(e) => { setHomeStaffStatusValue(e.currentTarget.value); setreportSection("") }}
                                        >
                                            Copy Policies
                                        </ToggleButton>
                                        <ToggleButton
                                            key='id3'
                                            id={`radioStaffHome-3`}
                                            type="radio"
                                            variant={'outline-success'}
                                            name="homeStaff-radio"
                                            size="sm"
                                        //disabled={userId == -1?false:true}
                                        //value={radio.value}
                                        // checked={homeStaffStatusValue === radio.value}
                                        // onChange={(e) => { setHomeStaffStatusValue(e.currentTarget.value); setreportSection("") }}
                                        >
                                            Copy Both
                                        </ToggleButton>


                                    </ButtonGroup>
                                </Form.Group>
                            </Row>
                            <Button variant="warning" onClick={handleShowOverWriteWarning}  >Save OverWrite Changes</Button>
                        </div> :
                        <div></div>}
                </Modal.Body>

                <Modal.Footer>

                    <Button variant="secondary" onClick={handleCloseCheckListRoleDetails} >
                        Close
                    </Button>

                </Modal.Footer>
            </Modal>
            <Modal style={{ marginLeft: "25%", marginTop: "10%", width: "50%" }} show={showOverwriteWarning} onHide={handleCloseOverwriteWarning} className=" custom-map-modal">
                <Modal.Header closeButton>
                    <Modal.Title> Confirm Overwrite</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    You will be overwriting the training template with the new selection - please confirm this action.

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleOverWriteRole(checkListRoleId)}>
                        Confirm
                    </Button>
                    <Button variant="primary" onClick={handleCloseOverwriteWarning}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>



            <Row>
                {/* <Col className='text-left text-muted'><h1>Home Position Template Details</h1></Col>
                <Col className='text-right'><Col>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip1}
                    >
                        <Button variant="warning" className="btn-md" onClick={() => getInitialData()} style={{ margin: "2%", float: "right", fontWeight: "1pc" }}><FiRefreshCw /></Button>
                    </OverlayTrigger>
                </Col><Col><Button variant='warning' onClick={handleShowPosition} className="btn-md" style={{ margin: "2%", float: "right" }} >Create New Template</Button></Col></Col> */}
                {/* <Col xs={12} md={6} className='text-left text-muted'>
                    <Typography variant="h5" component="h2">Home Position Template Details</Typography>
                </Col> */}
                {/* <Col className='text-right'>
                        
                        <Col>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip1}
                        >
                            <Button variant="warning" className="btn-md" onClick={() => getInitialData()} style={{ margin: "2%", float: "right", fontWeight: "1pc" }}><FiRefreshCw /></Button>
                        </OverlayTrigger>
                    </Col>
                    <Button variant='warning' onClick={(e) => {
                                { exportInExcel() }
                            }}>Export to Excel</Button>
                        <Col>
                            <Button variant='warning' onClick={handleShowPosition} className="btn-md" style={{ margin: "2%", float: "right" }} >Create New Template</Button>
                        </Col>
                    </Col> */}

                <Col xs={12} md={12}>
                    <Paper component="form" variant="outlined"
                        sx={{ float: "right", display: 'flex', marginBottom: "4px", alignItems: 'center', width: 150 }}>
                        <Tooltip variant="contained" title="Create New Policy" disableRipple>
                            <IconButton color="primary" onClick={() => handleShowPolicyDoc({})} sx={{ p: '10px' }} aria-label="directions">
                                <CreateNewFolderIcon />
                            </IconButton>
                        </Tooltip>
                        <Divider sx={{ height: 28, m: 0.5 }} color='primary' orientation="vertical" />
                        <Tooltip variant="contained" title="Refresh Data" disableRipple>
                            <IconButton color="primary" onClick={() => getInitialData()} sx={{ p: '10px' }} aria-label="directions">
                                <FiRefreshCw />
                            </IconButton>
                        </Tooltip>
                        <Divider sx={{ height: 28, m: 0.5 }} color='primary' orientation="vertical" />
                        <Tooltip variant="contained" title="Export to Excel" disableRipple>
                            <IconButton color="primary" onClick={() => exportInExcel()} sx={{ p: '10px' }} aria-label="directions">
                                <RiFileExcel2Line />
                            </IconButton>
                        </Tooltip>
                    </Paper>
                </Col>
            </Row>
            <Row >


                <div className="w-100">


                    {showSpinner ? <div style={{ paddingLeft: "50%", paddingTop: "10%", position: "absolute" }}>
                        <Spinner show={showSpinner} animation="border" size="lg" variant='primary' />

                    </div> : " "}
                    <div>
                        <Modal show={showPosition} onHide={handleClosePosition} style={{ width: "70%", left: "13%" }}>
                            <Modal.Header closeButton>
                                <Modal.Title>Add New Policy</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-2 col-xs-6" controlId="formBasicEmail">
                                        <Form.Label>Enter the Policy Name</Form.Label>
                                        <Form.Control type="text"
                                            onChange={(e) => {
                                                getPolicyText(e, 'pos1');
                                            }}
                                        />
                                        <Form.Label>Enter the Policy Details</Form.Label>
                                        <Form.Control type="text"
                                            onChange={(e) => {
                                                getPolicyText(e, 'pos2');
                                            }}
                                        />
                                        <Form.Label>Upload policy pdf</Form.Label>
                                        <Form.Control type="file" accept="application/pdf"
                                            onChange={(e) => {
                                                getPolicyText(e, 'pos3');
                                            }}
                                        />
                                        {!showDetailForm ? <Button style={{ margin: "1%" }} onClick={() => { handleShowDetailForm(); getOrgDetails() }}>Copy from existing</Button> :
                                            <div>                            <Button style={{ margin: "1%" }} onClick={() => { handleShowDetailForm(); clearAllSetting() }}>Hide Details</Button>
                                                <Row>
                                                    <h4>Copy Role specific policies</h4>
                                                    <Col>
                                                        <Form.Label>Organisation</Form.Label>
                                                        <Form.Select className="form-select-sm" aria-label="Default select example" onChange={selectOrgForRole}>
                                                            <option value=''>Select an Organization</option>
                                                            {orgList?.map((data) => {
                                                                return <option value={data.org_id}>{data.org_name}</option>;
                                                            })}
                                                        </Form.Select>
                                                    </Col>

                                                    <Col>
                                                        <Form.Label>Home</Form.Label>
                                                        <Form.Select className="form-select-sm" aria-label="Default select example" onChange={selectHomeForRole}>
                                                            <option value=''>Select a Home</option>

                                                            {homeList?.map((data) => {
                                                                if (data.homeActiveStatus === true) {
                                                                    return <option value={data.home_id}>{data.name}</option>;
                                                                } else {
                                                                    return null;
                                                                }
                                                            })}
                                                        </Form.Select>
                                                    </Col>



                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form.Label>Role</Form.Label>
                                                        <Form.Select className="form-select-sm" aria-label="Default select example" onChange={selectRoleForCopy}>
                                                            <option value=''>Select a Role</option>
                                                            {roleList?.map((data) => {
                                                                if (data.archived === "False" || data.archived === false) {
                                                                    return <option value={data.role_id}>{data.role_name}</option>;
                                                                } else {
                                                                    return null;
                                                                }
                                                            })}
                                                        </Form.Select>
                                                    </Col>
                                                    <Col></Col>
                                                </Row>


                                            </div>


                                        }

                                    </Form.Group>



                                    {showDetailForm ? <Form.Group className="mb-3 col-xs-6" controlId="formBasicEmail">
                                        <Row>
                                            <Col>
                                                <Form.Label style={{ display: "block" }}><b>Courses Mandatory for this Role : </b></Form.Label>
                                                {roleDetailOptions && roleDetailOptions.policy_arr ? (
                                                    roleDetailOptions.policy_arr.map((data, id) => {
                                                        return <ul key={id}>
                                                            <li><b>{data.id}</b> - {data.details}</li>
                                                        </ul>
                                                    })
                                                ) : (

                                                    <p>-</p>)
                                                }
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3 col-xs-6" controlId="formBasicEmail">
                                                    <Form.Label style={{ display: "block" }}><b>Present Courses for this Role : </b></Form.Label>
                                                    -
                                                </Form.Group>
                                            </Col>
                                        </Row>


                                    </Form.Group> : <div></div>}



                                </Form>

                            </Modal.Body>
                            <Modal.Footer>

                                <Button variant="secondary" onClick={handleClosePosition}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={savePositionDetail}  >
                                    Save Changes
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                    <div ref={ref} style={{ overflowY: "scroll", height: "90vh", overflowX: "auto" }}>
                        <Table striped bordered hover id="table-id" className='table-responsive' style={{ width: `${editTableWidth}` }}>
                            <thead style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: "98" }}>
                                <th style={{ width: `${editRowWidth}`, textAlign: "center", maxWidth: "5vh", left: "0px", backgroundColor: "rgb(255 255 255)", zIndex: "99", position: "sticky" }}>

                                    <Row style={{ justifyContent: "center" }}>

                                        <Col>
                                            <FormControl sx={{ width: "100%" }} size="small">
                                                <InputLabel id="demo-simple-select-label">Roles</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={selectedArchiveType.name}
                                                    label="Roles">
                                                    {archiveType?.map((item) => {
                                                        return <MenuItem value={item.name} onClick={() => handleArchiveTypeChange(item)}>{item.name}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <Paper component="form" variant="outlined"
                                                sx={{ display: 'flex', marginBottom: "2px", alignItems: 'center' }}>


                                                <Col >
                                                    <Tooltip variant="contained" title="Scroll Up">
                                                        <IconButton color="primary" onClick={() => scroll(-100, 'vertical')} aria-label="directions-up">
                                                            <KeyboardDoubleArrowUpOutlinedIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Col>
                                                <Divider sx={{ height: 28, m: 0.5 }} color='primary' orientation="vertical" />
                                                <Col >
                                                    <Tooltip variant="contained" title="Scroll Right">
                                                        <IconButton color="primary" onClick={() => scroll(100, 'horizontal')} aria-label="directions-right">
                                                            <KeyboardDoubleArrowRightOutlinedIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Col>
                                                <Divider sx={{ height: 28, m: 0.5 }} color='primary' orientation="vertical" />
                                                <Col >
                                                    <Tooltip variant="contained" title="Scroll Down">
                                                        <IconButton color="primary" onClick={() => scroll(100, 'vertical')} aria-label="directions-down">
                                                            <KeyboardDoubleArrowDownOutlinedIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Col>
                                                <Divider sx={{ height: 28, m: 0.5 }} color='primary' orientation="vertical" />
                                                <Col>
                                                    <Tooltip variant="contained" title="Scroll Left">
                                                        <IconButton color="primary" onClick={() => scroll(-100, 'horizontal')} aria-label="directions-left">
                                                            <KeyboardDoubleArrowLeftOutlinedIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Col>
                                            </Paper>
                                        </Col>
                                    </Row>
                                    <Typography variant='subtitle1' gutterBottom> Policy Title</Typography>
                                </th>

                                {roleDetails?.map((data, id) => {
                                    return <th key={id} style={{ width: "3vh", maxWidth: "5vh" }}>


                                        <Typography variant="subtitle1" style={{ textAlign: "center", cursor: "pointer" }}
                                        // onClick={(e) => { handleShowCheckListRoleDetails(e, data.home_id, data.role_id); }}
                                        >{data.role_name}</Typography>

                                        <p>

                                            <Modal show={roleDetailshow} onHide={handleroleDetailClose} style={{ width: "50%", left: "20%" }}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Role Details</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    {dispRoleDetail ?
                                                        <div>{dispRoleDetail.role_details}</div> : <div></div>

                                                    }


                                                </Modal.Body>
                                                <Modal.Footer>
                                                    {
                                                        (!sessionStorage.getItem('copyRoleObj')) ? <div></div> :
                                                            <Button variant="warning" onClick={handleOverWriteRole}>OverWrite Role Template</Button>
                                                    }

                                                    <Button variant="secondary" onClick={handleroleDetailClose} >
                                                        Close
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal></p>

                                    </th>
                                })
                                }


                            </thead>
                            <tbody>
                                {policyList?.map((courses, id) => {

                                    return <tr key={id} >
                                        <td style={{ position: "sticky", left: "0px", backgroundColor: "rgb(250 246 246)", width: "10vh", zIndex: "97" }}><b style={{ cursor: "pointer" }} onClick={(e) => {
                                            getMicrodetails(e, courses);
                                        }}>{courses.policyId}({courses.title})</b><div>

                                                <Modal show={MicroCredShow} onHide={handleCloseMicroCred}>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>View Policy Details</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <iframe
                                                            src={pdfUrl}
                                                            width="100%"
                                                            height="600px"
                                                            title="PDF Viewer"
                                                            style={{ border: "none", marginTop: "20px" }}
                                                        />


                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                    </Modal.Footer>
                                                </Modal>
                                            </div></td>


                                        {roleDetails?.map((role, roleIndex) => {
                                            const policyId = courses.policyId;

                                            // Check if this role exists in trainStandards
                                            const trainRole = trainStandards?.find(
                                                (r) => r.role_id === role.role_id
                                            );

                                            let isChecked = false;
                                            let isDisabled = false;

                                            if (trainRole) {
                                                // Role exists in trainStandards
                                                const trainHasPolicy = trainRole.policy_arr?.some(
                                                    (item) => item.policyId === policyId
                                                );

    if (trainHasPolicy) {
      isChecked = true;
      isDisabled = true;
    } else {
      // Role exists in trainStandards but doesn't have this policy
      // Proceed to roleDetails check
      const roleHasPolicy = role.policy_arr?.some(
        (item) => item?.policyId === policyId
      );

      isChecked = roleHasPolicy;
      isDisabled = false;
    }
  } else {
    // Role does NOT exist in trainStandards
    const roleHasPolicy = role.policy_arr?.some(
      (item) => item?.policyId === policyId
    );

                                                isChecked = roleHasPolicy;
                                                isDisabled = false;
                                            }

                                            return (
                                                <td key={`${policyId}-${role.role_id}`}>
                                                    <input
                                                        type="checkbox"
                                                        className="no"
                                                        style={{ transform: "scale(2)", marginLeft: "50%" }}
                                                        checked={isChecked}
                                                        disabled={isDisabled}
                                                        onChange={
                                                            !isDisabled
                                                                ? (e) => handleCheckOnChange(e, courses, role, roleIndex)
                                                                : undefined
                                                        }
                                                    />
                                                </td>
                                            );
                                        })}
                                    </tr>
                                })}

                            </tbody>

                        </Table>
                    </div>
                    <br></br>
                </div>


            </Row>
            <SuccessPopUp show={showSuccessPopup} data={dataForSuccessPopup} onHide={() => { setShowSuccessPopup(false) }} />
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
            <PolicyFormModal open={showPolicyDoc} initialData={policyData} onClose={handleClosePolicyDoc} onSubmitSuccess={(response) => {
                getInitialData();
            }} orgId="" homeId={props.id} />
            <PolicyViewModal
                open={policyViewModal}
                onClose={() => setPolicyViewModal(false)}
                policyData={{
                    policyId: pdfUrl.policyId,
                    versionNumber: 2,
                    archived: false,
                    isMajorChange: false,
                    title: pdfUrl.title,
                    type: "Test Type updated",
                    description: pdfUrl.description,
                    expiryValue: pdfUrl.expiry,
                    expiryType: pdfUrl.expiryType,
                    org_id: params,
                    home_id: "",
                    reAssignAll: false,
                    url: String(pdfUrl.url)
                }}
            />
        </div>
    );
}
